import { MarketPulseIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

export const APP_CONFIG_MARKET_PULSE: AppConfig = {
  name: 'Market Pulse',
  applicationKey: 'market-pulse',
  type: 'product',
  appSlugForEngagement: AppSlugs.MarketPulse,
  rootPath: `/market-pulse`,
  Icon: MarketPulseIcon,
  descriptionLong:
    'Access to Market Pulse endpoints at the zipcode, MSA, or state level',
  descriptionShort:
    'Access to Market Pulse endpoints at the zipcode, MSA, or state level',
};
